module.exports = __webpack_public_path__ + "static/media/digitalTerapeutics.548f53bb.jpg";